/**
 *  @class
 *  @function RecentlyViewedProducts
 */
window.recentlyViewedIds = [];
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url =Theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.product-grid');
      this.currentId = this.dataset.productHandle;
      this.max = this.dataset.productLimit;
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof(recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });
      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.product-grid');
          let recommendationsNew = recommendations.cloneNode(true)
          recommendationsNew.innerHTML = "";
          window.recentlyViewedIds.forEach((val) => {
            let filter = '[data-product-handle="'+val+'"]';
            let ele = html.querySelector(filter);
            if(ele){
              recommendationsNew.innerHTML += ele.outerHTML;
            }
          });
          if (recommendationsNew && recommendationsNew.innerHTML.trim().length) {
            this.container.innerHTML = recommendationsNew.innerHTML;
            this.classList.add('product-recommendations--loaded');
          }
          // this.querySelectorAll('.product-block').forEach((el) => el.classList.add('slider__item'));
          // this.querySelectorAll('carousel-slider').forEach((el) => el.refresh());
        //   theme.ProductBlockManager.loadImages(this.container);
          // theme.initAnimateOnScroll();
          // setTimeout(()=>{
          //   theme.loadCarousels();
          // },500)

        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}